import countryEn from './countryEn';
import countrySc from './countrySc';
import countryTc from './countryTc';

const country = { en: countryEn, sc: countrySc, tc: countryTc };

export default country;